/* Lightweight invalidation signal so all useExpenses/useExpense instances
   (list, detail drawer, sidebar counts) refetch after a mutation, without a
   provider wrapping the tree (keeps route tests simple). */

type Listener = () => void;

const listeners = new Set<Listener>();

export function subscribeExpenses(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function invalidateExpenses(): void {
  listeners.forEach((listener) => listener());
}
